"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@rmwc/icon/styles");
require("@rmwc/ripple/styles");
require("@rmwc/avatar/avatar.css");
